module.exports = __webpack_public_path__ + "img/home-1.160a2cd9.webp";